import { FC } from 'react';
import { Phone } from '@edikk-edikk/icon/Phone';
import { FormattedMessage } from 'react-intl';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailContactGroupCss from '../../assets/contacts/contact-group.module.scss';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';

const ContactsPhone: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!('phone' in contactData)) {
    return null;
  }

  return (
    <div className={advertDetailContactGroupCss.advertDetailContactGroup}>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__header}>
        <FormattedMessage defaultMessage="Phone number:" />
      </div>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__value}>
        <div className={advertDetailContactItemCss.advertDetailContactItem}>
          <SvgIcon Component={Phone} isWithoutFill width={20} height={20} />
          <a
            href={contactData.phone.url}
            target="_blank"
            rel="noopener noreferrer"
            className={advertDetailContactItemCss.advertDetailContactItem__link}
          >
            {contactData.phone.value}
          </a>
        </div>
      </div>
    </div>
  );
};

export { ContactsPhone };
